import { useState, useEffect } from 'react'
import { Flex, Box, Text, Heading, Card } from 'rebass/styled-components'
import { IProperties } from '../../../builder/types';

interface IFillingParagraphProps {
  properties: IProperties,
}

export const FillingParagraph: React.FC<IFillingParagraphProps> = ({ properties }) => {
  return (
    <>
      <Text fontWeight={300} style={{userSelect: 'none'}}>{`${((properties || {}).params || {}).question || 'Paragraph'}`}</Text>
    </>);
}